var _g, _g2, _g3, _g4;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrainstorming(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_1_imagine",
    "data-name": "1 imagine",
    xmlns: "http://www.w3.org/2000/svg",
    width: 96.43,
    height: 157.292,
    viewBox: "0 0 96.43 157.292",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_317",
    "data-name": "Group 317",
    transform: "translate(11.712 75.458)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_987",
    "data-name": "Path 987",
    d: "M-263.563,93.4c8.835,4.015,20.572,6.459,33.454,6.459s24.621-2.444,33.451-6.459c-8.831-4.01-20.567-6.454-33.451-6.454S-254.728,89.39-263.563,93.4Z",
    transform: "translate(263.563 -86.946)",
    fill: "#e6ae7e"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_333",
    "data-name": "Group 333",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_318",
    "data-name": "Group 318",
    transform: "translate(19.911 17.598)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_988",
    "data-name": "Path 988",
    d: "M-214.023,98.905a24.617,24.617,0,0,0,3.562-12.789A24.739,24.739,0,0,0-235.2,61.38,24.736,24.736,0,0,0-259.94,86.116a24.553,24.553,0,0,0,3.562,12.789c6.683,11.947,8.039,14.808,8.118,20.266.127,8.174,0,14.7,0,14.7h26.112s-.12-6.529,0-14.7C-222.06,113.713-220.708,110.852-214.023,98.905Z",
    transform: "translate(259.94 -61.38)",
    fill: "#f6cf85"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_319",
    "data-name": "Group 319",
    transform: "translate(35.368 93.828)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_989",
    "data-name": "Path 989",
    d: "M-243.831,95.063h-9.279c1.378,7.475,9.279,7.475,9.279,7.475s7.9,0,9.281-7.475Z",
    transform: "translate(253.11 -95.063)",
    fill: "#002254"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_320",
    "data-name": "Group 320",
    transform: "translate(27.814 77.384)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_990",
    "data-name": "Path 990",
    d: "M-222.777,92.09a4.293,4.293,0,0,1-4.3,4.293h-25.078a4.293,4.293,0,0,1-4.3-4.293h0a4.291,4.291,0,0,1,4.3-4.293h25.078a4.292,4.292,0,0,1,4.3,4.293Z",
    transform: "translate(256.448 -87.797)",
    fill: "#768296"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_321",
    "data-name": "Group 321",
    transform: "translate(29.161 77.384)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_991",
    "data-name": "Path 991",
    d: "M-224.873,91.248a3.729,3.729,0,0,1-3.956,3.454H-251.9a3.725,3.725,0,0,1-3.951-3.454h0A3.723,3.723,0,0,1-251.9,87.8h23.073a3.727,3.727,0,0,1,3.956,3.451Z",
    transform: "translate(255.853 -87.797)",
    fill: "#aebfce"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_322",
    "data-name": "Group 322",
    transform: "translate(27.814 85.796)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_992",
    "data-name": "Path 992",
    d: "M-222.777,95.812a4.294,4.294,0,0,1-4.3,4.3h-25.078a4.293,4.293,0,0,1-4.3-4.3h0a4.3,4.3,0,0,1,4.3-4.3h25.078a4.3,4.3,0,0,1,4.3,4.3Z",
    transform: "translate(256.448 -91.514)",
    fill: "#768296"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_323",
    "data-name": "Group 323",
    transform: "translate(43.475)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_993",
    "data-name": "Path 993",
    d: "M-247.835,53.6a1.7,1.7,0,0,1,1.7,1.7v9.876a1.694,1.694,0,0,1-1.7,1.686h0a1.687,1.687,0,0,1-1.693-1.686V55.3a1.692,1.692,0,0,1,1.693-1.7Z",
    transform: "translate(249.528 -53.604)",
    fill: "#ffa229"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_324",
    "data-name": "Group 324",
    transform: "translate(21.872 5.605)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_994",
    "data-name": "Path 994",
    d: "M-258.23,56.308a1.686,1.686,0,0,1,2.306.618l4.938,8.555a1.68,1.68,0,0,1-.618,2.3h0a1.685,1.685,0,0,1-2.306-.616l-4.938-8.552a1.694,1.694,0,0,1,.618-2.308Z",
    transform: "translate(259.074 -56.08)",
    fill: "#ffa229"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_325",
    "data-name": "Group 325",
    transform: "translate(5.958 21.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_995",
    "data-name": "Path 995",
    d: "M-265.881,63.839a1.7,1.7,0,0,1,2.311-.616l8.552,4.938a1.69,1.69,0,0,1,.616,2.311h0a1.689,1.689,0,0,1-2.3.618l-8.555-4.94a1.7,1.7,0,0,1-.62-2.311Z",
    transform: "translate(266.105 -62.997)",
    fill: "#ffa229"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_326",
    "data-name": "Group 326",
    transform: "translate(0 42.769)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_996",
    "data-name": "Path 996",
    d: "M-268.738,74.193a1.7,1.7,0,0,1,1.7-1.691h9.876a1.694,1.694,0,0,1,1.691,1.691h0a1.693,1.693,0,0,1-1.691,1.693h-9.876a1.694,1.694,0,0,1-1.7-1.693Z",
    transform: "translate(268.738 -72.502)",
    fill: "#ffa229"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_327",
    "data-name": "Group 327",
    transform: "translate(5.605 59.437)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_997",
    "data-name": "Path 997",
    d: "M-266.034,87.342a1.691,1.691,0,0,1,.618-2.308l8.548-4.938a1.688,1.688,0,0,1,2.313.62h0a1.683,1.683,0,0,1-.618,2.306l-8.55,4.938a1.692,1.692,0,0,1-2.311-.618Z",
    transform: "translate(266.261 -79.867)",
    fill: "#ffa229"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_328",
    "data-name": "Group 328",
    transform: "translate(60.145 5.605)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_998",
    "data-name": "Path 998",
    d: "M-234.691,56.308a1.69,1.69,0,0,0-2.308.618l-4.936,8.555a1.682,1.682,0,0,0,.62,2.3h0a1.686,1.686,0,0,0,2.308-.616l4.94-8.552a1.688,1.688,0,0,0-.625-2.308Z",
    transform: "translate(242.162 -56.08)",
    fill: "#ffa229"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_329",
    "data-name": "Group 329",
    transform: "translate(72.442 21.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_999",
    "data-name": "Path 999",
    d: "M-225.02,63.839a1.694,1.694,0,0,0-2.311-.616l-8.552,4.938a1.7,1.7,0,0,0-.622,2.311h0a1.7,1.7,0,0,0,2.315.618l8.552-4.94a1.687,1.687,0,0,0,.618-2.311Z",
    transform: "translate(236.729 -62.997)",
    fill: "#ffa229"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_330",
    "data-name": "Group 330",
    transform: "translate(77.076 42.769)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1000",
    "data-name": "Path 1000",
    d: "M-221.43,74.193a1.691,1.691,0,0,0-1.691-1.691h-9.872a1.69,1.69,0,0,0-1.688,1.691h0a1.689,1.689,0,0,0,1.688,1.693h9.872a1.69,1.69,0,0,0,1.691-1.693Z",
    transform: "translate(234.681 -72.502)",
    fill: "#ffa229"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_331",
    "data-name": "Group 331",
    transform: "translate(72.796 59.437)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1001",
    "data-name": "Path 1001",
    d: "M-224.867,87.342a1.69,1.69,0,0,0-.62-2.308l-8.546-4.938a1.692,1.692,0,0,0-2.315.62h0a1.691,1.691,0,0,0,.625,2.306l8.55,4.938a1.685,1.685,0,0,0,2.306-.618Z",
    transform: "translate(236.572 -79.867)",
    fill: "#ffa229"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_332",
    "data-name": "Group 332",
    transform: "translate(29.161 85.796)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1002",
    "data-name": "Path 1002",
    d: "M-224.873,94.974a3.731,3.731,0,0,1-3.956,3.454H-251.9a3.726,3.726,0,0,1-3.951-3.454h0a3.729,3.729,0,0,1,3.951-3.46h23.073a3.733,3.733,0,0,1,3.956,3.46Z",
    transform: "translate(255.853 -91.514)",
    fill: "#aebfce"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_337",
    "data-name": "Group 337",
    transform: "translate(11.312 0.484)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_334",
    "data-name": "Group 334",
    transform: "translate(0 9.387)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1003",
    "data-name": "Path 1003",
    d: "M-259.967,135.276l-3.773-1.562,10.9-26.327,7.521,12.023,13.1-27.4,11.254,13.7,12.456-28.7,5.917,11.062,16.169-30.109,3.6,1.933-19.776,36.826-5.525-10.332-11.751,27.084-11.424-13.907-13.532,28.311-7.258-11.605Z",
    transform: "translate(263.739 -57.966)",
    fill: "#1c4670"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_336",
    "data-name": "Group 336",
    transform: "translate(70.763)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_335",
    "data-name": "Group 335"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1004",
    "data-name": "Path 1004",
    d: "M-218.117,70.1l-.5-16.286-13.853,8.576Z",
    transform: "translate(232.472 -53.818)",
    fill: "#1c4670"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_338",
    "data-name": "Group 338",
    transform: "translate(6.382 81.939)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1005",
    "data-name": "Path 1005",
    d: "M-193.624,116.83h-.663c.281-2.281.57-4.522.842-6.647.584-4.479,1.467-12.474-.292-20.373-8.831,3.994-20.543,6.432-33.4,6.432s-24.569-2.437-33.4-6.432c-1.758,7.9-.88,15.894-.294,20.373.276,2.125.561,4.366.842,6.647h-.663c-5.834-4.318-6.326,6.955-3.895,10.809a23.312,23.312,0,0,1,3.277,7.05c.905,2.594,2.39,2.933,3.637,2.652.156,1.537.292,2.874.389,3.938.534,5.925,14.776,17.8,18.01,21.511,3.017,3.481,8.066,2.125,9.682,2.055,1.639-.079,2.412-.12,2.412-.12s.774.041,2.408.12c1.618.07,6.663,1.426,9.688-2.055,3.232-3.716,17.469-15.586,18.006-21.511.1-1.064.238-2.4.387-3.938,1.254.281,2.741-.059,3.639-2.652a23.423,23.423,0,0,1,3.277-7.05C-187.294,123.784-187.794,112.512-193.624,116.83Z",
    transform: "translate(265.918 -89.81)",
    fill: "#f4c297"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrainstorming);
export default __webpack_public_path__ + "static/media/brainstorming.ba2bdc9e67e825e425ec7ea0e939e47b.svg";
export { ForwardRef as ReactComponent };